import React from "react"
import BlockWrapper from "@yumgmbh/gatsby-theme-yum-components/src/components/technical/BlockWrapper"
import Headline from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Headline"
import NexmartDealerFinder from "gatsby-theme-rothenberger/src/components/modules/NexmartDealerFinder"

import { useTranslation } from "react-i18next"

const DealerFinderBlock = ({ block }) => {
  const { t } = useTranslation()

  return (
    <BlockWrapper
      block={block}
      blockPadding="pb-8"
      blockWidth="screen"
      showHeadline="false"
      className="bg-ro-gray-50"
    >
      <div className="block-w-container">
        <div className="py-8">
          {block.headline && (
            <Headline headline={block.headline} className="mb-2" />
          )}
          <div className="lg:w-1/2">
            {t("generic.products.intro_dealer_search")}
          </div>
        </div>
      </div>
      <NexmartDealerFinder />
    </BlockWrapper>
  )
}

export default DealerFinderBlock
